import { render, staticRenderFns } from "./CalcSettings.vue?vue&type=template&id=5416b82e&scoped=true"
import script from "./CalcSettings.vue?vue&type=script&lang=ts"
export * from "./CalcSettings.vue?vue&type=script&lang=ts"
import style0 from "./CalcSettings.vue?vue&type=style&index=0&id=5416b82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5416b82e",
  null
  
)

export default component.exports